// extracted by mini-css-extract-plugin
export default {"dropzoneArea":"dropzone_dropzoneArea__egHf5","filePreview":"dropzone_filePreview__wJzyb","fileList":"dropzone_fileList__fZ7st","fileName":"dropzone_fileName__0rOT+"};